<template>
  <div class="flex justify-between align-center mb-2 p-2" :class="`list-group-item-${$queueHelper.getColorByStatus(extension.status)}`">
    <div v-text="extension.extension"></div>
    <div v-html="extension.text != null && extension.text.length > 0 ? extension.text : '--'"></div>
    <div v-html="extension.name != null && extension.name.length > 0 ? extension.name : '--'"></div>
    <div v-html="extension.time" class="mb-0"></div>
    <div>
      <vs-button
        class="text-white"
        color="success"
        type="filled"
        @click.prevent="$emit('enable')"
        v-if="!extension.enabled" v-text="$t('enable')"
        size="small">
      </vs-button>

      <vs-button
        class="text-white"
        color="danger"
        type="filled"
        @click.prevent="$emit('disable')"
        v-else
        size="small">
      </vs-button>
    </div>
  </div>
</template>

<script>
import QueueExtensionMixin from '@/mixins/queueExtensionMixin'

export default {
  name: 'Shared.Queues.Extensions.List',
  mixins: [QueueExtensionMixin]
}
</script>

<style lang="scss">
  .list-group-item-success {
    border: 1px solid;
    border-color: rgba(var(--vs-success),1)!important;
    color: #0f695f;
    background-color: #c0f0eb;
  }
  .list-group-item-danger {
    border: 1px solid;
    border-color: rgba(var(--vs-danger),1)!important;
    color: #841e3f;
    background-color: #fec8da;
  }
  .list-group-item-warning {
    border: 1px solid;
    border-color: rgba(var(--vs-warning),1)!important;
    color: #856012;
    background-color: #ffebc1;
  }
  .list-group-item-primary {
    border: 1px solid;
    border-color: rgba(var(--vs-primary),1)!important;
    color: #2c3e7a;
    background-color: #cfd9f9;
  }

</style>
